import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '@context/useAuthStore';

const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="w-12 h-12 border-4 border-t-transparent border-blue-500 dark:border-blue-400 rounded-full animate-spin"></div>
    </div>
  );
};

const RequireSubscription = ({ children }) => {
  const { subscription, subscriptionLoading } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (!subscriptionLoading && subscription === 'NOT_FOUND') {
      navigate('/subscription');
    }
  }, [subscription, subscriptionLoading, navigate]);

  if (subscriptionLoading) return <LoadingSpinner />;

  return children;
};

export default RequireSubscription;
